import HandshqApp from '../handshq-app';

HandshqApp.toggleHelpers = {
  setupReplaceToggle() {
    $("[data-toggle='replace'").on('click', function () {
      const targetSelector = $(this).data().target;
      $(targetSelector).toggleClass('hide');
      $(this).toggleClass('hide');
    });
  },

  setupRevealToggle() {
    if ($("[data-toggle='reveal']").length) {
      const eventTrigger = $("[data-toggle='reveal']").data().trigger;
      $("[data-toggle='reveal'").on(eventTrigger, function () {
        const targetSelector = $(this).data().target;
        $(targetSelector).removeClass('hide');
      });
    }
  },
};

$(() => {
  HandshqApp.toggleHelpers.setupReplaceToggle();
  HandshqApp.toggleHelpers.setupRevealToggle();
});
